import { forwardRef, ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";

const pill = cva(
  "inline-flex items-center justify-center gap-2 rounded-full font-medium transition-all duration-200 active:scale-[0.98] disabled:opacity-50 disabled:pointer-events-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 whitespace-nowrap",
  {
    variants: {
      variant: {
        primary:
          "bg-[hsl(var(--mkt-cta))] text-[hsl(var(--mkt-cta-fg))] hover:bg-[hsl(240_10%_15%)] shadow-sm",
        accent:
          "bg-[hsl(var(--mkt-primary))] text-white hover:bg-[hsl(var(--mkt-primary-deep))] shadow-sm",
        outline:
          "bg-transparent text-foreground border border-foreground/15 hover:bg-foreground/[0.04]",
        white:
          "bg-card text-foreground hover:bg-white/90 shadow-sm",
        ghost:
          "bg-transparent text-foreground hover:bg-foreground/[0.05]",
      },
      size: {
        sm: "h-9 px-4 text-sm",
        md: "h-11 px-6 text-sm",
        lg: "h-12 px-7 text-[15px]",
        xl: "h-14 px-8 text-base",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  }
);

export interface PillButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof pill> {}

export const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button ref={ref} className={cn(pill({ variant, size }), className)} {...props} />
  )
);
PillButton.displayName = "PillButton";
